import type { ZudokuPlugin } from "zudoku";

export interface GoogleAnalyticsOptions {
  measurementId: string;
}

export function googleAnalyticsPlugin(
  options: GoogleAnalyticsOptions,
): ZudokuPlugin {
  const { measurementId } = options;

  return {
    getHead: () => (
      <>
        <script
          async
          src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`}
        />
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${measurementId}');
          `}
        </script>
      </>
    ),
  };
}